module.exports = __webpack_public_path__ + "static/img/医院信息化项目管理系统.63b5d6f.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/webSite/著作权/医院信息化项目管理系统.png
// module id = KORB
// module chunks = 1